import styled from '@emotion/styled';

export type TabProps = {
  active: boolean;
};

const Tab = styled('div')<TabProps>(
  {
    display: 'inline-flex',
    alignContent: 'center',
    width: 'fit-content',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '7px 15px',
    margin: '22px 0px 28px 0px',
    borderRadius: 6,
    cursor: 'pointer'
  },
  ({ active, theme }) => ({
    ...(active && {
      backgroundColor: theme.palette.colors.azureish,
      cursor: 'default'
    })
  })
);

export default Tab;
